import { configuration } from '../configuration';

interface UrlServiceResponse {
  url: string;
}

const FALLBACK_PATH = '/search';
const FETCH_TIMEOUT_MS = 2000;

export async function getSearchPath(tenant: string, locale: string): Promise<string> {
  const url = `${configuration.urls.URL_SERVICE_URL}v3/url/${encodeURIComponent(tenant)}/${encodeURIComponent(locale)}/other:search?requestor=${encodeURIComponent(configuration.requestor)}`;

  try {
    const response = await fetch(url, { signal: AbortSignal.timeout(FETCH_TIMEOUT_MS) });

    if (!response.ok) {
      console.error(`UrlService: failed to fetch search path for ${tenant}/${locale}: ${response.status}`);
      return FALLBACK_PATH;
    }

    const { url: searchPath } = (await response.json()) as UrlServiceResponse;
    return searchPath;
  } catch (error) {
    console.error(`UrlService: error fetching search path for ${tenant}/${locale}`, error);
    return FALLBACK_PATH;
  }
}
